import g from "./globals";
import Logger from "./Logger";
import api from "./api";
import dom from "./dom";
import cookies from "./cookies";

const logger = new Logger(__filename);
const zara = window.zara;
const urls = {};
// TODO: esto no es core
const siteLinks = {
  sustainability: 841535,
  sustainabilityCollectionProgram: 967749,
  sustainabilityOurProducts: 1209523,
  "sustainabilityOurProducts-S": 1211507,
  sustainabilityOurSuppliers: 967751,
  sustainabilityOurStores: 967752,
  sustainabilityGreenWeb: 967753,
  sustainabilityAnnualReport2015: 861068,
  sustainabilityRoppongiExhibition: 1112001,
  sustainabilityJoinlifeCollectionHomewear: 1125522,
  sustainabilityJoinlifeCollectionKIDS: 1088537,
  "sustainabilityJoinlifeCollectionKIDS-C": 1080583,
  "sustainabilityJoinlifeCollectionKIDS-S": 1056203,
  sustainabilityJoinlifeCollectionWOMAN: 1080582,
  "sustainabilityJoinlifeCollectionWOMAN-S": 1081167,
  sustainabilityJoinlifeCollectionMAN: 1080581,
  "sustainabilityJoinlifeCollectionMAN-S": 1081166,
  sustainabilityJoinlifeCollectionTRF: 1106503,
  sustainabilityJoinlifeCollectionTRF2: 1158063,
  "sustainabilityJoinlifeCollectionTRF-S": 1116501,
  sustainabilitySocialAction: 1018001,
  clothesCollecting: 967749,
  "clothesCollecting-S": 967749,
  jlwomanN: 1181467,
  jlmanN: 1181468,
  jlkidsN: 742047,
  jlwomanS: 1009985,
  jlmanS: 1009885,
  jlkidsS: 1241695,
  jlboxes: 967748,
};

export const getCategoryName = () => {
  const globalCategoryName = zara && (zara.categoryName || (zara.mkt && zara.mkt.categoryName));
  return globalCategoryName || document.querySelector("html").id || document.body.id;
};

export const getCategoryIdentifier = () => zara?.viewPayload?.category?.key || getCategoryName();

// TODO: REFACTORIZAR GETCATEGORYID A GLOBALES??
export const getCategoryId = () => {
  const href = window.location.href.replace(/#.*/, "");
  if (/^[^?]+-c(\d+)/.test(href) || /categoryId=(\d+)/.test(href)) {
    return RegExp.$1;
  }
  if (!zara) return null;
  if (zara.categoryId) return zara.categoryId;
  if (zara.viewPayload && zara.viewPayload.category) {
    return zara.viewPayload.category.id;
  }
  if (zara.context && zara.context.analyticsData && zara.context.analyticsData.catGroupId) {
    return zara.context.analyticsData.catGroupId;
  }
  return null;
};

// eslint-disable-next-line max-statements
export const urlTo = (location, ...args) => {
  let categoryId;
  // TODO: REFACTORIZAR MÉTODO
  if (location === "category" && args[0]) {
    categoryId = args[0];
    if (categoryId && g.channels.apps) {
      return `zara:///1/catalog/category/${categoryId}`;
    }
    const category = g.categories[categoryId];
    if (category) {
      const options = Object.assign({}, category, args[1]);
      return api.buildUrl("category", options);
    }

    const menuEntry = document.querySelector(`*[data-categoryid='${categoryId}'] a`);

    if (menuEntry) {
      return menuEntry.getAttribute("href");
    }

    const e =
      document.querySelector(`[data-viewcategoryid='${categoryId}']>a`) ||
      document.querySelector(`[data-categoryid='${categoryId}']>a`) ||
      document.querySelector(`[data-id='${categoryId}']>a`);

    let href;
    if (e) {
      href = e.attributes["data-href"] ? e.attributes["data-href"].value : e.href;
    }
    if (href) {
      return `${href}`;
    }
    return `/${g.storeCode}/${g.langCode}/_/_/_-c${categoryId}.html`;
  }

  if (location === "sitelink" && args.length > 0) {
    let href = args[0] || "#";
    if (g.channels.apps) {
      href = href.replace(/.*\?v1=(.*)/, "zara:///1/catalog/category/$1");
    }
    return href;
  }
  if (location === "product" && args.length > 0) {
    const product = args[0];
    const region = args[2];
    const isMarketing = /^Marketing$/i.test(product?.kind);
    const regionObject = isMarketing && (region || product?.marketingMetaInfo?.mappingInfo[0]?.regions[0]);
    const productId = isMarketing ? regionObject?.link?.id : product?.id || product;
    if (productId) {
      const categoryId = args[1] || getCategoryId();
      const productData = regionObject
        ? {
            id: productId,
            seo: {
              keyword: regionObject.link?.seoKeyword,
              discernProductId: productId,
              seoProductId: regionObject.link?.seoId,
            },
          }
        : product;
      const url = api.buildUrl("product", productData, categoryId);
      const root = `/${g.storeCode}/${g.langCode}`;
      if (!categoryId || ((!product.bundleProductSummaries || !product.bundleProductSummaries.length) && product.type === "Bundle")) {
        return null;
      } else if (g.channels.minip) {
        if (typeof product === "object" && product.type === "Product") {
          return `/pages/product/product?productId=${productId}`;
        } else {
          return `/pages/editProductList/editProductList?editorialsId=${productId}`;
        }
      } else if (g.channels.apps) {
        return `zara:///1/product/id/${productId}`;
      } else if (url && !/undefined/.test(url)) {
        return url;
      } else if (product.seo) {
        return `${root}/${product.seo.keyword}-p${product.seo.seoProductId}.html?v1=${product.id}&v2=${categoryId}`;
      }
      return `${root}/_/_/_-c${categoryId}p${productId}.html?v1=${productId}&v2=${categoryId}`;
    }
    return null;
  }
  if (location === "category.rest") {
    const categoryId = args[0] || zara.mkt.categoryId;
    if (!categoryId) return;
    return `/itxrest/1/catalog/store/${g.storeId}/category/${categoryId}/product?languageId=${g.langId}`;
  }
  logger.log(`urlTo ${location} not implemented`);
  return null;
};

export const retrieveSiteLinks = (channels = g.channels) => {
  let url;
  if (channels.standalone || channels.minip) {
    return {};
  }
  const siteLinksExposed = document.querySelector("#site-links");
  const exposedUrls = siteLinksExposed ? JSON.parse(siteLinksExposed.innerHTML) : {};
  if (exposedUrls) {
    Object.keys(exposedUrls).map(key => {
      url = exposedUrls[key];
      switch (false) {
        case typeof url.trim !== "function":
          urls[key] = url.trim();
          break;
        case !url.length:
          urls[key] = "";
          for (const _url of Array.from(url)) {
            if (_url.trim()) {
              urls[key] = _url;
              urls[`${key}.fallback`] = url[url.length - 1];
              break;
            }
          }
          break;
        default:
          break;
      }
      return url;
    });
  }
  return urls;
};

export const initURLS = channels => {
  const links = {};
  Object.keys(siteLinks).map(siteLink => {
    const id = siteLinks[siteLink];
    links[siteLink] = urlTo("category", id);
    return links;
  });
  Object.assign(urls, links);
  return retrieveSiteLinks(channels);
};

export const firstSubcategory = () => {
  let href = null;
  if (!g.channels.apps && !g.channels.minip) {
    const categoryId = getCategoryId();
    let context = null;
    if (categoryId) {
      context = document.querySelector(dom.buildSelector(categoryId));
    }
    if (context) {
      const context = document.querySelector(dom.buildSelector(categoryId));
      const linksWrapper = context.querySelector("._category-link-wrapper") || context.querySelector(".menu-parent");
      if (!linksWrapper) return null;
      const menuEntry = linksWrapper.querySelector("a");
      const extraquery = menuEntry.getAttribute("data-extraquery");
      const query = extraquery ? `?${extraquery}` : "";
      const link = menuEntry.getAttribute("href") || menuEntry.getAttribute("data-href");
      href = `${link}${query}`;
    }
  }
  return href;
};

const _mapMktChannelToItxrestChannel = mktChannel => {
  const channelEquivalences = {
    desktop: "web",
    mobile: "web-mobile",
    apps: "app",
    minip: "minip",
  };

  return channelEquivalences[mktChannel] || "web";
};

export const getItxrestSpotsUrl = (spot, channel, store, languageId) => {
  const requestQueryString = [];
  requestQueryString.push(`channel=${_mapMktChannelToItxrestChannel(channel)}`);
  requestQueryString.push(`languageId=${languageId}`);
  requestQueryString.push(`spot=${spot}`);

  const workspaceCookie = cookies.read("zcmng_renderer_workspace");
  if (!g.production && workspaceCookie) {
    requestQueryString.push(`workspace=${workspaceCookie}`);
  }
  return `${g.basePath}/itxrest/2/marketing/store/${store}/spot?${requestQueryString.join("&")}`;
};

export const getEndpoint = ({ endpoint, page, categoryIdentifier, live }) => {
  let spot = `ESpot_${page}`;
  if (categoryIdentifier) {
    spot = `ESpot_${categoryIdentifier}`;
  }
  const endpoints = {
    products: `${g.basePath}/itxrest/1/catalog/store/${g.storeId}/category/${getCategoryId()}/product/?languageId=${g.langId}`,
    static: `${g.staticContent}/spots/${page}/__${g.storeCode}__.json?ts=${g.lastStaticSyncTimestamp}`,
    live: `${live}?name=#${getCategoryName()}&channel=default"`,
    leaker: `contents/${page}-page.json`,
    itxrestSpots: getItxrestSpotsUrl(spot, g.channel, g.storeId, g.langId),
  };
  return endpoints[endpoint];
};

export const isNavigable = categoryId => {
  const category = g.categories[categoryId];
  if (!category) return false;

  const blocked = category.attributeList.some(({ key, value }) => {
    if (key.match("SHOW_IN_HOME|SECTION_[MAN|WOMAN|KID]") && value === "true") {
      return value;
    }
    return false;
  });
  if (blocked) return false;

  const navigable = category.attributeList.filter(({ key }) => key === "ACCESIBLE").some(attr => attr.value === "true");
  if (navigable) return true;
  let element =
    document.querySelector(`[data-viewcategoryid='${categoryId}']`) ||
    document.querySelector(`[data-categoryid='${categoryId}']`) ||
    document.querySelector(`[data-id='${categoryId}']`);
  const isParentCategory = element && element.querySelector("ul");
  return !isParentCategory;
};
